import React, { PureComponent } from 'react'

import classes from './SetupCompetencyScore.scss'
import moment from 'moment'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Card from '../../../../components/UI/Card/Card'
import PleaseFilter from '../../../../components/PleaseFilter/PleaseFilter'
// import _ from 'lodash'

import Alert from '../../../../components/Alert/Alert'
import SetupCompetencyScoreBody from '../../../../components/PageContent/SetupData/SetupCompetencyScore/SetupCompetencyScoreBody/SetupCompetencyScoreBody'
import SetupCompetencyScoreHeader from '../../../../components/PageContent/SetupData/SetupCompetencyScore/SetupCompetencyScoreHeader/SetupCompetencyScoreHeader'
import EditModal from './EditModal/EditModal'
import Form from './Form/Form'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import Modal from '../../../../components/UI/Modal/Modal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import FilterBar from '../../../../components/FilterBar/FilterBar'
// import ActionBar from '../../../../components/ActionBar/ActionBar'
import {
  updateFormOptions,
  checkValidity,
  updateFilterOptions,
  updateObject
} from '../../../../helpers/utils'
import Spinner from '../../../../components/UI/Spinner/Spinner'
// import ImportModal from '../../../../components/PageContent/AppraisalItem/ImportModal/ImportModal'
import { CardHeader, Grid } from '@material-ui/core'
import { withTranslate } from 'react-redux-multilingual'
import PageInfo from '../../../../components/PageInfo/PageInfo'
import Footer from '../../../../components/UI/Modal/Footer/Footer'

class SetupCompetencyScore extends PureComponent {
  state = {
    modalOpen: false,
    editModalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    filter: {},
    formValid: false,
    action: 'add',
    addAno: false,
    addAnoHandler: false,
    actionRecordId: null,
    inputGroups: {
      company_id: {
        label: this.props.translate('company'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('company') }
          ]
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      csg_name: {
        label: this.props.translate('competencyScoreGroupName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('competencyScoreGroupName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      effective_date: {
        label: this.props.translate('effectiveDate'),
        elementType: 'datePicker',
        elementConfig: {
          type: 'text'
        },
        value: null,
        validation: {
          required: true,
          type: 'date'
        },
        valid: false,
        touched: false,
        error: null
      }
    },
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('company') }
          ]
        }
      },
      // csg_id: {
      //     label: this.props.translate('competencyScoreGroup'),
      //     value: null,
      //     configs: { placeholder: this.props.translate('competencyScoreGroup'), options: [], clearDisabled: true }
      // }
      csg_id: {
        label: this.props.translate('competencyScoreGroup'),
        value: '',
        configs: {
          placeholder:
            this.props.translate('select') + this.props.translate('competencyScoreGroup'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('competencyScoreGroup')
            }
          ]
        }
      }
    },
    updateProps: {
      selectedRecord: this.props.selectedRecord,
      companyOptions: this.props.companyOptions,
      competencyScoreGroupOptions: this.props.competencyScoreGroupOptions
    },
    csg_id: null,
    company: null,
    collapse: [],
    collapseCheck: null,
    data: null,
    structureId: null,
    loadingStates: null,
    type: null,
    actionCheck: false,
    param: null,
    filtered: false
  }

  componentDidMount() {
    this.props.fetchCompanyOptions()

    if (this.props.filtered) {
      this.props.fetchCompetencyScoreGroup(this.props.filtered)
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.success !== this.props.success && this.props.success) {
      this.clearModal()
      this.clearModalHandler()
    }
  }

  componentWillUnmount() {
    this.props.clearSelectedRecord()
  }

  static getDerivedStateFromProps = (props, state) => {
    if (props.data !== state.data) {
      let data = props.data
      let collap = []
      let company = []
      Object.entries(data).reduce((updatedData, data) => {
        let [dataKey, dataAttrs] = data

        if (dataKey === 'csg_data') {
          collap = dataAttrs.map(attrs => {
            return {
              csg_id: attrs.csg_id,
              open: false
            }
          })
        } else if (dataKey === 'company_data') {
          company = dataAttrs
          return company
        }
        return data
      }, {})
      // let collap = data.map(item => {
      //   return {
      //     csg_id: item.csg_id,
      //     open: false
      //   }
      // })

      return {
        collapse: collap,
        data: props.data,
        company: company
      }
    }
    let updatedState = {}
    let { updateProps } = state
    const updateOptions = (stateId, propsId, attr) => {
      const inputGroups = state.inputGroups
      const targetLevelItem = inputGroups[stateId]
      let [attrId, attrName, attrPlaceHolder] = attr

      updatedState = updateObject(updatedState, {
        inputGroups: updateObject(inputGroups, {
          [stateId]: updateFormOptions(
            props[propsId],
            targetLevelItem,
            attrId,
            attrId,
            attrName,
            attrPlaceHolder
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    const updateFilter = (stateId, propsId, attr) => {
      let [attrId, attrName] = attr

      updatedState = updateObject(updatedState, {
        filterControls: updateObject(state.filterControls, {
          [stateId]: updateFilterOptions(
            props[propsId],
            state.filterControls[stateId],
            attrId,
            attrId,
            attrName,
            null,
            null,
            state.filterControls[stateId].value
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    if (props.companyOptions !== updateProps.companyOptions) {
      updateOptions('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' },
        'Select Company'
      ])
      updateFilter('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' }
      ])
    }

    if (props.competencyScoreGroupOptions !== updateProps.competencyScoreGroupOptions) {
      updateFilter('csg_id', 'competencyScoreGroupOptions', ['csg_id', 'csg_name'])
    }

    if (props.selectedRecord !== updateProps.selectedRecord) {
      let newFormData = Object.entries(state.inputGroups).reduce((formGroups, form) => {
        let [formKey, formAttrs] = form
        let value = ''
        let valid = false
        let touched = false
        let errorMessage = null
        if (!formAttrs.validation || !formAttrs.validation.required) {
          valid = true
        }
        if (formAttrs.elementType === 'checkbox') {
          value = 0
        } else if (formAttrs.elementType === 'datePicker') {
          value = null
        }
        if (props.selectedRecord && props.selectedRecord[formKey]) {
          value = props.selectedRecord[formKey]
          if (formAttrs.elementType === 'datePicker') {
            value = new Date(props.selectedRecord[formKey])
          }

          let { isValid, error } = checkValidity(value, formAttrs.validation, formAttrs.label)
          if (formAttrs.elementType === 'newselect') {
            value = state.inputGroups[formKey].elementConfig.options.find(
              res => res.value === value
            )
          }
          valid = isValid
          errorMessage = error
        }

        const newFormAttrs = {
          ...formAttrs,
          value: value,
          valid: valid,
          error: errorMessage,
          touched: touched
        }

        return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
      }, {})
      updatedState = {
        ...updatedState,
        inputGroups: newFormData,
        formValid: true,
        updateProps: {
          ...updateProps,
          selectedRecord: props.selectedRecord
        }
      }
    }
    return updatedState
  }

  inputChangeHandler = (groupKey, formKey, event) => {
    const inputGroup = this.state.inputGroups
    const formItem = inputGroup[formKey]
    let inputValue = ''

    switch (formItem.elementType) {
      case 'textEditor':
        inputValue = event.target.getContent()
        break
      case 'newselect':
        inputValue = event
        break
      case 'checkbox':
        inputValue = formItem.value === 0 ? 1 : 0
        break
      case 'datePicker':
        inputValue = event
        break

      default:
        inputValue = event.target.value
        break
    }

    const { isValid, error } = checkValidity(inputValue, formItem.validation, formItem.label)

    const updatedFormItem = {
      ...formItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }
    const updateGroup = updateObject(inputGroup, { [formKey]: updatedFormItem })
    let formIsValid = true
    Object.values(updateGroup).map(attr => {
      return (formIsValid = formIsValid && attr.valid)
    })

    this.setState({
      inputGroups: updateObject(this.state.inputGroups, { [formKey]: updatedFormItem }),
      formValid: formIsValid
    })
  }

  closeEditModal = () => {
    if (this.state.action === 'edit') {
      this.clearModalHandler()
    } else {
      // this.clearModalHandler()
      this.setState({
        editModalOpen: false
      })
    }
  }

  clearModalHandler = () => {
    // this.closeEditModal()
    this.props.clearSelectedRecord()
    if (this.state.addAnoHandler) {
      this.setState({
        actionRecordId: null,
        formValid: false,
        addAnoHandler: false,
        editModalOpen: true
      })
    } else {
      this.setState({
        actionRecordId: null,
        formValid: false,
        editModalOpen: false
      })
    }
  }

  closeModal = () => {
    if (this.state.action === 'edit') {
      this.clearModal()
    } else {
      this.clearModal()
      this.setState({
        modalOpen: false
      })
    }
  }

  clearModal = () => {
    this.clearInput()
    this.props.clearSelectedRecordGroup()
    if (this.state.addAno) {
      this.setState({
        actionRecordId: null,
        formValid: false,
        addAno: false
      })
    } else {
      this.setState({
        actionRecordId: null,
        formValid: false,
        modalOpen: false
      })
    }
  }

  clearInput = () => {
    let newFormData = Object.entries(this.state.inputGroups).reduce((formGroups, form) => {
      let [formKey, formAttrs] = form
      let newFormAttrs
      switch (formKey) {
        case 'effective_date':
          newFormAttrs = {
            ...formAttrs,
            value: null
          }
          break
        default:
          newFormAttrs = {
            ...formAttrs,
            value: ''
          }
          break
      }

      return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
    }, {})
    this.setState({ inputGroups: newFormData })
  }

  openModal = () => {
    this.setState({
      modalOpen: true,
      formValid: false
    })
  }

  openEditModal = () => {
    this.setState({
      editModalOpen: true
    })
  }

  openModalMain = (action, csg_id, type) => {
    if (csg_id && action === 'edit') {
      this.props.fetchCompetencyScoreGroupById(csg_id)
    }

    this.setState({
      action: action,
      type: type,
      csg_id
    })

    if (action === 'delete') {
      this.openConfirmationModal(csg_id)
    } else {
      this.openModal()
    }
  }

  openModalHandler = (action, recordId, csg_id, type) => {
    this.props.fetchEditOptions(this.state.filterControls.company_id.value?.value, csg_id)
    if (recordId && action === 'edit') {
      this.props.fetchCompetencyScoreById(recordId)
    }

    this.setState({
      action: action,
      actionRecordId: recordId,
      type: type,
      csg_id
    })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.openEditModal()
    }
  }

  deleteRecord = type => {
    if (type === 'g') {
      this.props.deleteCompetencyScoreGroup(this.state.csg_id, {
        company_id: this.state.param.company_id
      })
      this.closeConfirmationModal()
    } else {
      const recordId = this.state.actionRecordId
      // const filterOptions = extractFilterOptions(this.state.filterControls)
      this.props.deleteCompetencyScore(recordId, { company_id: this.state.param.company_id })
      // this.props.filterAppraisalItemOptions(filterOptions)
      this.closeConfirmationModal()
    }
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false,
      actionRecordId: null,
      action: 'add',
      actionCheck: false,
      type: null
    })
  }

  openConfirmationModal = recordId => {
    if (recordId) {
      this.setState({
        confirmationModalOpen: true,
        actionCheck: true
      })
    }
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    this.setState({
      filterModalOpen: true
    })
  }

  formSubmitHandler = (recordData, type) => {
    if (this.state.action === 'add') {
      this.props.createCompetencyScore(
        {
          ...recordData,
          csg_id: this.state.csg_id
        },
        { company_id: this.state.param.company_id }
      )
      if (type === 'saveAno') {
        this.setState({
          addAnoHandler: true
        })
      }
      // this.closeEditModal()
    } else if (this.state.action === 'edit') {
      this.props.updateCompetencyScore(
        this.state.actionRecordId,
        {
          ...recordData,
          csg_id: this.state.csg_id
        },
        { company_id: this.state.param.company_id }
      )
      // this.closeEditModal()
    }
  }

  competencyScoreGroupSubmitHandler = type => {
    let competencyScoreGroupData = Object.entries(this.state.inputGroups).reduce(
      (competencyScoreGroupData, competencyScoreGroupEntry) => {
        let value = ''
        let [competencyScoreGroupKey, competencyScoreGroupAttrs] = competencyScoreGroupEntry
        if (competencyScoreGroupAttrs.elementType === 'newselect') {
          value = competencyScoreGroupAttrs.value?.value
        } else if (competencyScoreGroupAttrs.elementType === 'datePicker') {
          value = moment(competencyScoreGroupAttrs.value).format('YYYY-MM-DD')
        } else {
          value = competencyScoreGroupAttrs.value
        }
        return updateObject(competencyScoreGroupData, { [competencyScoreGroupKey]: value })
      },
      {}
    )
    if (this.state.action === 'add') {
      this.props.createCompetencyScoreGroup(
        { ...competencyScoreGroupData },
        { company_id: competencyScoreGroupData.company_id }
      )
      if (type === 'saveAno') {
        this.setState({
          addAno: true
        })
      }
    } else if (this.state.action === 'edit') {
      this.props.updateCompetencyScoreGroup(
        this.state.csg_id,
        { ...competencyScoreGroupData },
        { company_id: competencyScoreGroupData.company_id }
      )
    }
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]
    if (itemKey === 'company_id') {
      this.props.fetchScoreGroupOptions({ company_id: filterValue?.value })
    }
    this.setState({
      filterControls: updateObject(this.state.filterControls, {
        [itemKey]: {
          ...filterItem,
          value: filterValue
        }
      }),
      filter: {
        ...this.state.filter,
        [itemKey]: itemKey !== 'company_id' ? null : filterValue?.value,
        csg_name: itemKey !== 'csg_id' ? null : filterValue?.label
      }
    })
  }

  filterRecords = (event, page) => {
    let param = { ...this.state.filter }

    this.props.fetchCompetencyScoreGroup(param)

    this.setState({
      param: param,
      filtered: true
    })
    this.closeFilterModal()
  }

  toggleCollapse = id => {
    let collap = this.state.collapse.map(item => {
      if (item.csg_id === id) {
        return {
          ...item,
          open: !item.open
        }
      } else {
        return item
      }
    })
    let check = collap.find(item => item.open === true)

    this.setState({
      collapse: collap,
      collapseCheck: check?.csg_id
    })
  }

  render() {
    let setupCompetencyScoreBody = <PleaseFilter />

    if (this.state.filtered === true) {
      if (this.props.filterLoading === true) {
        setupCompetencyScoreBody = <Spinner />
      } else {
        setupCompetencyScoreBody = (
          <SetupCompetencyScoreBody
            competencyData={this.props.data?.csg_data}
            open={this.state.collapse}
            adding={csg_id => this.openModalHandler('add', null, csg_id)}
            editing={(recordId, csg_id) => this.openModalHandler('edit', recordId, csg_id)}
            editingGroup={csg_id => this.openModalMain('edit', csg_id)}
            deleting={recordId => this.openModalHandler('delete', recordId, null, 's')}
            deletingGroup={csg_id => this.openModalMain('delete', csg_id, 'g')}
            addDisabled={!this.props.pagePermission.is_add}
            editDisabled={!this.props.pagePermission.is_edit}
            deleteDisabled={!this.props.pagePermission.is_delete}
            collap={id => this.toggleCollapse(id)}
            collapseCheck={this.state.collapseCheck}
            actionCheck={this.state.actionCheck}
            loading={this.props.loading}
            eftdText={this.props.translate('effectiveDate')}
          />
        )
      }
    }

    // let

    // if (this.state.filtered) {
    //   setupCompetencyScoreBody = <PleaseFilter />
    //   if (this.props.filterLoading) {
    //     setupCompetencyScoreBody = <Spinner />
    //   }
    // }

    // if (!this.props.loading) {
    //     setupCompetencyScoreBody = <PleaseFilter />
    // }

    // let importDisabled = true
    // const pagePermission = this.props.pagePermission

    // if (pagePermission.is_add && pagePermission.is_edit) {
    //     importDisabled = false
    // }

    const formLabel = Object.entries(this.state.inputGroups).map((item, key) => {
      return (
        <Form
          key={key}
          form={item}
          inputChanged={(formKey, e) => this.inputChangeHandler(key, formKey, e)}
          formValid={this.state.formValid}
        />
      )
    })

    const footer = (
      <Footer
        save={() => this.competencyScoreGroupSubmitHandler('save')}
        another={() => this.competencyScoreGroupSubmitHandler('saveAno')}
        showAnother={this.state.action === 'add'}
        cancel={() => this.closeModal()}
        disable={!this.state.formValid}
      />
    )

    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={() => this.deleteRecord(this.state.type)}
          promptText={this.props.translate('confirmDel')}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={
            this.props.translate(this.state.action) + this.props.translate('competencyScoreGroup')
          }
          backdropClicked={this.closeModal}
          footer={footer}>
          <div className={classes.ModalBody}>{formLabel}</div>
        </Modal>
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <EditModal
          open={this.state.editModalOpen}
          onHide={this.closeEditModal}
          onSave={this.formSubmitHandler}
          action={this.state.action}
          backdropClicked={this.closeEditModal}
        />
        <div className={classes.AppraisalItemWrapper}>
          <Card>
            <CardHeader
              title={
                <Grid container>
                  <Grid item xs={12} sm md>
                    <PageInfo pageTranslateKey={'competencyScore'} />
                  </Grid>
                  <Grid item xs sm md={4}>
                    <FilterBar buttonClicked={this.openFilterModal} />
                  </Grid>
                </Grid>
              }
            />
            {this.state.filtered === true ? (
              <SetupCompetencyScoreHeader
                companyData={this.state?.company}
                buttonClicked={this.openModal}
              />
            ) : null}
            {setupCompetencyScoreBody}
          </Card>
        </div>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    companyOptions: state.competencyScore.companies,
    competencyScoreGroupOptions: state.competencyScore.competencyScoreGroupOptions,
    data: state.competencyScore.competencyScoresGroup,
    loadingStates: state.competencyScore.loadingStates,
    loading: state.competencyScore.loading,
    modalLoading: state.competencyScore.modalLoading,
    selectedRecord: state.competencyScore.selectedRecord,
    success: state.competencyScore.success,
    filtered: state.competencyScore.filtered,
    filterLoading: state.competencyScore.filterLoading
  }
}

const mapDispatchToProps = dispatch => {
  return {
    // competency score group
    fetchCompetencyScoreGroup: filterOptions =>
      dispatch(actions.fetchCompetencyScoreGroup(filterOptions)),
    fetchCompetencyScoreGroupById: recordId =>
      dispatch(actions.fetchCompetencyScoreGroupById(recordId)),
    clearSelectedRecordGroup: () => dispatch(actions.clearSelectedCompetencyScoreGroupRecord()),
    createCompetencyScoreGroup: (recordData, param) =>
      dispatch(actions.createCompetencyScoreGroup(recordData, param)),
    updateCompetencyScoreGroup: (recordId, recordData, param) =>
      dispatch(actions.updateCompetencyScoreGroup(recordId, recordData, param)),
    deleteCompetencyScoreGroup: (recordId, param) =>
      dispatch(actions.deleteCompetencyScoreGroup(recordId, param)),

    // competency score
    fetchCompetencyScore: filterOptions => dispatch(actions.fetchCompetencyScore(filterOptions)),
    fetchCompetencyScoreById: recordId => dispatch(actions.fetchCompetencyScoreById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedCompetencyScoreRecord()),
    createCompetencyScore: (recordData, param) =>
      dispatch(actions.createCompetencyScore(recordData, param)),
    updateCompetencyScore: (recordId, recordData, param) =>
      dispatch(actions.updateCompetencyScore(recordId, recordData, param)),
    deleteCompetencyScore: (recordId, param) =>
      dispatch(actions.deleteCompetencyScore(recordId, param)),
    fetchCompanyOptions: () => {
      dispatch(actions.fetchCompanyOptions())
    },
    fetchScoreGroupOptions: filterOptions =>
      dispatch(actions.fetchCompetencyScoreGroupOptions(filterOptions)),
    // fetchStructureOptions: filterOptions => {
    //     dispatch(actions.fetchStructureOptionsForAppraisal(filterOptions))
    // },
    fetchFilter: () => {
      dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchCompetencyScoreGroupOptions())
    },
    fetchEditOptions: (company_id, filterOptions) => {
      dispatch(
        actions.fetchStructureOptionsForAppraisal({
          ...filterOptions,
          company_id: company_id,
          structure_type_code: ['STT02']
        })
      )
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(SetupCompetencyScore))
